<template>
    <v-footer ref="footer" app absolute color="yellow darken-3" class="site-footer">
        <v-container class="py-8">
            <v-row>
                <v-col cols="4">
                    <v-img class="" width="120" src="/logo_black.svg">
                    </v-img>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4">
                    <label class="d-block">66/7-9 ซอยสุขาภิบาล 2 ซอย 31 แขวงดอกไม้ เขตประเวศ กรุงเทพมหานคร 10250</label>
                </v-col>
                <v-col class="border-left footer-links" cols="12" sm="3">
                    <v-btn v-for="link in footerLinks" :key="link.text" class="d-block" text :to="link.to">{{ link.text }}</v-btn>
                </v-col>
                <v-col class="border-left" cols="12" sm="3">
                    <label class="d-block mb-1">ติดต่อเรา</label>
                    <label class="d-block mb-1">อีเมลล์ movevai.th@gmail.com</label>
                    <label class="d-block mb-1">
                        <v-icon size="16">mdi-phone</v-icon> 02-613-0885
                    </label>
                    <label class="d-block mb-1">
                        <v-icon size="16">mdi-phone</v-icon> 099-5098405
                    </label>
                    <div class="line-it-button" data-lang="th" data-type="friend" data-env="REAL" data-count="true"
                        data-lineId="@thespykid1412" data-home="true" style="display: none;"></div>
                </v-col>
                <v-col cols="6" sm="2">
                    <!-- aspect-ratio กัน footer สูงขึ้นหลังรูปโหลดเสร็จ ซึ่งทำให้ v-main
                         จองพื้นที่ท้ายหน้าไว้น้อยเกินจนเนื้อหาถูกแถบ footer ทับบนจอมือถือ -->
                    <v-img width="70%" aspect-ratio="1" src="/images/qr.png"></v-img>
                </v-col>
            </v-row>

            <!-- แถบกฎหมายล่างสุด: แยกลิงก์เอกสารของ Messenger ออกจากเมนูเว็บ
                 เพื่อให้หาได้จากทุกหน้า (Google Play ต้องเห็นลิงก์คำขอลบบัญชี) -->
            <div class="footer-legal">
                <span>Copyright © {{ currentYear }} Movevai co, ltd.</span>
                <span class="footer-legal__links">
                    <span class="footer-legal__label">Messenger</span>
                    <template v-for="(link, index) in legalLinks">
                        <span v-if="index" :key="`${link.text}-sep`" class="footer-legal__sep">·</span>
                        <router-link :key="link.text" :to="link.to" class="footer-legal__link">{{ link.text }}</router-link>
                    </template>
                </span>
            </div>
        </v-container>
    </v-footer>
</template>

<script>
export default {
    data: () => ({
        footerLinks: [
            { text: 'หน้าแรก', to: { name: 'Home' } },
            { text: 'เกี่ยวกับเรา', to: { name: 'About' } },
            { text: 'บริการของเรา', to: { name: 'Services' } },
            // ข่าวประชาสัมพันธ์ย้ายมาอยู่ใน footer อย่างเดียว (เอาออกจากเมนูด้านบนเพราะยังไม่มีข่าว)
            { text: 'ข่าวประชาสัมพันธ์', to: { name: 'AnnouncementHome' } },
            { text: 'เช็คสถานะ', to: { name: 'Status' } },
            { text: 'ติดต่อเรา', to: { name: 'Contact' } }
        ],
        /* ชื่อสั้นได้เพราะมีป้าย "Messenger" นำหน้าแถบอยู่แล้ว
           (title ของหน้ายังเป็นชื่อเต็มใน router) */
        legalLinks: [
            { text: 'นโยบายความเป็นส่วนตัว', to: { name: 'MessengerPrivacy' } },
            { text: 'ขอลบบัญชี', to: { name: 'MessengerAccountDeletion' } }
        ]
    }),
    /* Vuetify วัดความสูง footer ครั้งเดียวตอน mount แล้วเผื่อพื้นที่ท้าย v-main ตามนั้น
       ถ้าความสูงเปลี่ยนทีหลัง (หมุนจอ, ขนาดจอเปลี่ยน, ฟอนต์/รูปโหลดเสร็จ) footer จะทับเนื้อหา
       จึงสั่งให้วัดใหม่ทุกครั้งที่ขนาด footer เปลี่ยน */
    mounted() {
        if (typeof ResizeObserver === 'undefined') return;
        const footer = this.$refs.footer;
        this.footerObserver = new ResizeObserver(() => footer.callUpdate());
        this.footerObserver.observe(footer.$el);
    },
    beforeDestroy() {
        if (this.footerObserver) this.footerObserver.disconnect();
    },
    computed: {
        /* ปี copyright เดินตามปีปัจจุบัน (อ่านตามเวลาไทย ไม่ใช่ timezone ของเครื่อง)
           ไม่ต้องมีใครมาแก้ทุกต้นปี */
        currentYear() {
            return new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Bangkok', year: 'numeric' }).format(new Date());
        }
    }
};
</script>

<style scoped>
.site-footer {
    height: auto !important;
    min-height: 300px;
}

.border-left{
    border-left: 1px solid #666666;
}

.footer-links .v-btn {
    height: auto !important;
    justify-content: flex-start;
    letter-spacing: normal;
    min-height: 28px;
    min-width: 0;
    padding: 2px 8px;
    text-transform: none;
}

/* keep the routed link looking like the others instead of staying highlighted on its own page */
.footer-links .v-btn--active::before {
    opacity: 0;
}

.footer-links .v-btn:hover::before,
.footer-links .v-btn:focus::before {
    opacity: 0.08;
}

.footer-links .v-btn ::v-deep .v-btn__content {
    display: block;
    line-height: 1.4;
    text-align: left;
    white-space: normal;
}

.footer-legal {
    align-items: center;
    border-top: 1px solid #666666;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 16px;
    justify-content: space-between;
    margin-top: 16px;
    padding-top: 12px;
}

.footer-legal__links {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.footer-legal__label {
    margin-right: 4px;
    opacity: 0.75;
}

.footer-legal__link {
    color: inherit;
    text-decoration: none;
}

.footer-legal__link:hover,
.footer-legal__link:focus {
    text-decoration: underline;
}

.footer-legal__sep {
    margin: 0 4px;
}

@media (max-width: 600px) {
    .site-footer {
        min-height: 0;
    }

    .border-left {
        border-left: 0;
        border-top: 1px solid #666666;
        margin-top: 16px;
        padding-top: 16px;
    }

    /* จอแคบ: ป้าย Messenger ขึ้นบรรทัดแรก แล้วลิงก์ซ้อนบรรทัดละอัน กดง่ายกว่าเรียงต่อกัน */
    .footer-legal__links {
        align-items: flex-start;
        flex-direction: column;
        gap: 6px;
    }

    .footer-legal__sep {
        display: none;
    }
}
</style>
